<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group
          :label="serviceQuestion.label"
          :label-cols="3"
          :horizontal="true"
        >
          <b-select
            v-if="serviceQuestion && serviceQuestion.input_type === 'select'"
            v-model="value"
            :options="
              serviceQuestion.values ? serviceQuestion.values.explode(',') : []
            "
          />
          <b-checkbox
            v-else-if="
              serviceQuestion &&
              serviceQuestion.input_type === 'checkbox' &&
              serviceQuestion.values.explode(',').length <= 1
            "
            v-model="value"
            :value="serviceQuestion.values"
          />
          <b-checkbox-group
            v-else-if="
              serviceQuestion &&
              serviceQuestion.input_type === 'checkbox' &&
              serviceQuestion.values.explode(',').length > 1
            "
            type="number"
            v-model="selected"
            :options="
              serviceQuestion.values ? serviceQuestion.values.explode(',') : []
            "
          />
          <b-input
            v-else-if="
              serviceQuestion && serviceQuestion.input_type === 'number'
            "
            type="number"
            v-model="value"
          />
          <b-input
            v-else-if="serviceQuestion && serviceQuestion.input_type === 'text'"
            type="text"
            v-model="value"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "ServiceQuestion",
  components: { Multiselect },
  props: {
    serviceQuestion: {
      type: Object,
      default: () => null,
    },
    serviceAnswer: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      selected: [],
      value: null,
    };
  },
  watch: {
    value: {
      handler() {
        this.$emit("answeredQuestion", {
          id:
            this.serviceAnswer && this.serviceAnswer.id
              ? this.serviceAnswer.id
              : null,
          service_question_id: this.serviceQuestion.id,
          label: this.serviceQuestion.label,
          value: this.value,
        });
      },
      deep: true,
    },
  },
  created() {
    if (this.serviceAnswer) {
      this.value = this.serviceAnswer.value;
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
